import React from "react";
import Label from "./ui/Label";
import { useCurrencies, useCurrencyEnabled } from "../hooks/useCompanySettings";
import { i18n } from "@euroland/libs";
import { useTemplateSetting } from "../hooks/useCompanySettings";
import { TOOL_TEMPLATE } from "../constant/common";
import useCurrencyName from "../hooks/useCurrencyName";
import { Dropdown, Option } from "@euroland/dropdown-react";

const CurrenciesSelect = ({ onChange, selectedCurrency }) => {
  const textLocalCurrency = i18n.translate("localCurrency");

  const currencies = useCurrencies();
  const currencyEnabled = useCurrencyEnabled();
  const template = useTemplateSetting();
  const isQuadrata = template === TOOL_TEMPLATE.quadrata;
  const currencyLabel = isQuadrata
    ? i18n.translate("labelCurrencySelectQuadrata")
    : i18n.translate("labelCurrencySelectVictor");
  const getCurrencyNameByCode = useCurrencyName();
  return (
    <>
      {currencyEnabled && (
        <div className="select-currency">
          <Label>{currencyLabel}</Label>
          <Dropdown
            value={selectedCurrency}
            dropdownMenuLabel="dropdown currency"
            placeholder={currencyLabel}
            onOptionSelect={val => onChange?.(val)}
            icon={isQuadrata && <span className="fs-triangle-down fs-icon"></span>}
            aria-label={currencyLabel}
          >
            <Option value={textLocalCurrency} key={textLocalCurrency}>
              {textLocalCurrency}
            </Option>
            {currencies.map(({ code, text }) => (
              <Option value={code} key={code} aria-label={`${code} ${getCurrencyNameByCode(code)}`}>
                {text || code}
              </Option>
            ))}
          </Dropdown>
        </div>
      )}
    </>
  );
};

export default React.memo(CurrenciesSelect);
